
  (function () {
    'use strict';

    let moved = false;
    let wrapper = null;

    function isMobile() {
      return window.innerWidth <= 767.98;
    }

    function moveToMobile() {
      if (moved) return;

      const qty = document.querySelector('.product-qty-mobile-wrapper');
      const reviews = document.querySelector('.AirReviews-Widget--AppBlockSummary');
      const block = document.querySelector('.shopify-app-block');

      if (!qty || !reviews || !block) return;

      // Create wrapper
      wrapper = document.createElement('div');
      wrapper.className = 'qty-reviews-row';
      wrapper.style.cssText = 'display: flex; align-items: center; justify-content: space-between; gap: 12px;';

      // Insert wrapper
      block.insertBefore(wrapper, block.firstChild);

      // Move elements
      wrapper.appendChild(reviews);
      const selector = qty.querySelector('.qty-selector');
      if (selector) wrapper.appendChild(selector);

      qty.style.display = 'none';
      moved = true;
    }

    function moveToDesktop() {
      if (!moved || !wrapper) return;

      const qty = document.querySelector('.product-qty-mobile-wrapper');
      const reviews = document.querySelector('.qty-reviews-row .AirReviews-Widget--AppBlockSummary');
      const selector = document.querySelector('.qty-reviews-row .qty-selector');
      const block = document.querySelector('.shopify-app-block');

      if (!qty || !block) return;

      // Restore reviews
      if (reviews) block.insertBefore(reviews, block.firstChild);

      // Restore quantity
      if (selector) qty.appendChild(selector);

      // Remove wrapper
      if (wrapper.parentElement) wrapper.remove();

      qty.style.display = 'none';
      moved = false;
      wrapper = null;
    }

    function update() {
      if (isMobile()) {
        moveToMobile();
      } else {
        moveToDesktop();
      }
    }

    // Initialize with retry
    let attempts = 0;
    function init() {
      const reviews = document.querySelector('.AirReviews-Widget--AppBlockSummary');
      const qty = document.querySelector('.product-qty-mobile-wrapper');

      if (reviews && qty) {
        update();
      } else if (attempts < 30) {
        attempts++;
        setTimeout(init, 100);
      }
    }

    // Start immediately
    init();

    // Handle resize
    let timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(update, 100);
    });
  })();



  // Update discount badge when variant changes
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      const priceWrapper = document.querySelector('[data-price-wrapper]');
      if (!priceWrapper) return;

      // Listen for variant change event
      document.addEventListener('variant:change', function(e) {
        const variant = e.detail.variant;
        const discountBadge = priceWrapper.querySelector('[data-discount-badge]');
        
        if (variant && variant.compare_at_price > variant.price) {
          const discountAmount = variant.compare_at_price - variant.price;
          const discountPercentage = Math.round((discountAmount / variant.compare_at_price) * 100);
          
          if (discountBadge) {
            discountBadge.textContent = discountPercentage + '% OFF!';
            discountBadge.style.display = 'inline-block';
          }
        } else if (discountBadge) {
          discountBadge.style.display = 'none';
        }
      });
    });
  })();
